<template>
  <div class="max-w-[2560px] mx-auto">
    <div>
      <div>
        <navigation-bar></navigation-bar>
      </div>
      <div>
        <header-component
          :img="eventsHeader.image_path"
          :title="getLocalized(eventsHeader, 'title')"
          :detailed="getLocalized(eventsHeader, 'description')"
        ></header-component>
      </div>
      <div>
        <event-component></event-component>
      </div>
      <div>
        <footer-view></footer-view>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationBar from "@/view/NavigationBar.vue";
import HeaderComponent from "./HeaderComponent.vue";
import EventComponent from "../components/Events/eventComponent.vue";
import axios from "axios";
import FooterView from "./footerView.vue";
import { useLocalization } from "@/composable/useLocalization";
export default {
  components: {
    NavigationBar,
    HeaderComponent,
    EventComponent,
    FooterView,
  },
  mounted() {
    this.fetchHeaderEvents();
  },
  data() {
    return {
      api: process.env.VUE_APP_API_KEY,
      eventsHeader: {},
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  methods: {
    async fetchHeaderEvents() {
      try {
        const response = await axios.get(this.api + "/api/sliders");

        this.eventsHeader = response.data.items
          .map((item) => ({
            ...item,
            image_path: `${this.api}${item.image_path}`,
          }))
          .find(
            (item) =>
              item.display_order === 3 || item.title_en === "News & Events"
          );
      } catch (error) {
        console.error("Error fetching events header:", error.message);
      }
    },
  },
};
</script>

<style></style>
